__turbopack_context__.v({
  "denomination": "EffektTextInput-module-scss-module__mGDo4W__denomination",
  "rounded": "EffektTextInput-module-scss-module__mGDo4W__rounded",
  "textInput": "EffektTextInput-module-scss-module__mGDo4W__textInput",
  "textInputWrapper": "EffektTextInput-module-scss-module__mGDo4W__textInputWrapper",
  "underlined": "EffektTextInput-module-scss-module__mGDo4W__underlined",
});
